<script>
	export default {
		name: 'LangExecuter',
		methods: {
			getLangsVal(key, language) {
				const self_ = this;

				const langs_ = self_.getLocalStorage('langs')

				let language_ = null
				if(self_.isFalse(language)) { language_ = self_.getAppState('language') }
				else { language_ = language }

				const mobileScreen_ = self_.getAppState('isMobileScreen')

				if(self_.isEmpty(langs_) || self_.isFalse(key)) { return null }
				else {
					if(self_.isEmpty(langs_[key])) { return key }

					if(langs_[key][language_]) { 
						// { key: { language: { mobile: val, web: val } } }
						if(self_.isResponsive(langs_[key][language_])) {
							if(mobileScreen_) {
								return langs_[key][language_].mobile
							} else { return langs_[key][language_].web }
						// { key: { language: val } }
						} else {
							return langs_[key][language_]
						}
					} else { 
						// { key: { default: {mobile: val, web: val } } }
						if(self_.isResponsive(langs_[key].default)) { 
							if(mobileScreen_) {
								return langs_[key].default.mobile
							} else { return langs_[key].default.web }
						// { key: { default: val } }
						} else { 
							return langs_[key].default
						}
					}
				}
			}
		}
	}
</script>